<template>
  <layout>
    <template v-slot:title>Login Successful</template>
  </layout>
</template>
<script>
import auth from "@/services/auth/authService";
import tokenStorage from "@/services/auth/tokenStorageService";

export default {
  mounted: function() {
    const vm = this;
    auth
      .receiveCode()
      .then((result) => {
        if (Office.context.ui && typeof Office.context.ui.messageParent === 'function') {
          Office.context.ui.messageParent(JSON.stringify(result));
        } else {
          tokenStorage.setAccessToken(result.accessToken);
          tokenStorage.setRefreshToken(result.refreshToken);
          vm.logInfo("Access tokens set.");

          vm.$store.commit("loggedIn");
          vm.logInfo("User has successfully logged in.");
L
          vm.$router.push(result.state || "/");
        }
      })
      .catch((error) => {
        vm.logError("Error logging in.", { error });
        console.error(error);
        vm.$router.push("/?nologon=true");
      });
  },
};
</script>
